/**
 * NotFoundPage — 404 fallback.
 */

import { Link } from 'react-router-dom';
import { FileQuestion } from 'lucide-react';

export function NotFoundPage() {
    return (
        <div className="text-center py-16 animate-fade-in">
            <FileQuestion className="w-12 h-12 mx-auto text-zinc-300 dark:text-zinc-600 mb-4" />
            <h2 className="text-xl font-semibold text-zinc-900 dark:text-zinc-100 mb-2">
                Page Not Found
            </h2>
            <p className="text-sm text-zinc-500 dark:text-zinc-400 mb-6">
                The page you're looking for doesn't exist.
            </p>
            <Link
                to="/lookup"
                className="inline-flex items-center gap-2 px-4 py-2 text-sm font-medium text-white bg-indigo-600 rounded-lg hover:bg-indigo-700 transition-colors"
            >
                Go to License Lookup
            </Link>
        </div>
    );
}
